var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.customer
    ? _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        fab: "",
                        fixed: "",
                        bottom: "",
                        right: "",
                        large: "",
                        color: "primary"
                      },
                      on: { click: _vm.showModal }
                    },
                    [_c("v-icon", [_vm._v("edit")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-btn", { attrs: { small: "", to: "/customers" } }, [
                    _vm._v("Back to Customers")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.customer.firstName) +
                                      " " +
                                      _vm._s(_vm.customer.lastName)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v("Phone:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            { staticClass: "align-end" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "tel:" +
                                                      _vm.customer.phone
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.customer.phone)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v("Address:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            { staticClass: "align-end" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    href:
                                                      "https://maps.google.com/?q=" +
                                                      _vm.customer.address
                                                        .address +
                                                      ", " +
                                                      _vm.customer.address
                                                        .city +
                                                      " " +
                                                      _vm.customer.address
                                                        .state +
                                                      " " +
                                                      _vm.customer.address
                                                        .postcode
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.customer.address
                                                        .address
                                                    )
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.customer.address.city
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.customer.address
                                                          .state
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.customer.address
                                                          .postcode
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v("Email:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            { staticClass: "align-end" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "" + _vm.customer.email
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.customer.email)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.events
                    ? _c("v-layout", [_c("h2", [_vm._v("Timeline")])])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orders
                    ? _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _c("h4", [_vm._v("Past Orders")])
                          ]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-xl": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-list",
                                        { attrs: { dense: "" } },
                                        _vm._l(_vm.orders, function(
                                          order,
                                          index
                                        ) {
                                          return _c(
                                            "v-list-tile",
                                            { key: index },
                                            [
                                              _c("v-list-tile-content", [
                                                _vm._v(_vm._s(order.orderCode))
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                { staticClass: "align-end" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "primary",
                                                      attrs: {
                                                        small: "",
                                                        to:
                                                          "/order/" + order._id
                                                      }
                                                    },
                                                    [_vm._v("Details")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      model: {
                        value: _vm.isModalVisible,
                        callback: function($$v) {
                          _vm.isModalVisible = $$v
                        },
                        expression: "isModalVisible"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "headline grey lighten-2",
                              attrs: { "primary-title": "" }
                            },
                            [_vm._v("Edit Customer")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c("h3", { staticClass: "headline" }, [
                                _vm._v("Customer Details")
                              ]),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "First Name" },
                                model: {
                                  value: _vm.customer.firstName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "firstName", $$v)
                                  },
                                  expression: "customer.firstName"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Last Name" },
                                model: {
                                  value: _vm.customer.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "lastName", $$v)
                                  },
                                  expression: "customer.lastName"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Email" },
                                model: {
                                  value: _vm.customer.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "email", $$v)
                                  },
                                  expression: "customer.email"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Phone" },
                                model: {
                                  value: _vm.customer.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "phone", $$v)
                                  },
                                  expression: "customer.phone"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: {
                                  type: "checkbox",
                                  label: "Newsletter?",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.customer.newsletter,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "newsletter", $$v)
                                  },
                                  expression: "customer.newsletter"
                                }
                              }),
                              _vm._v(" "),
                              _c("h3", { staticClass: "headline" }, [
                                _vm._v("Address")
                              ]),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Address" },
                                model: {
                                  value: _vm.customer.address.address,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.customer.address,
                                      "address",
                                      $$v
                                    )
                                  },
                                  expression: "customer.address.address"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Suburb" },
                                model: {
                                  value: _vm.customer.address.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer.address, "city", $$v)
                                  },
                                  expression: "customer.address.city"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "State" },
                                model: {
                                  value: _vm.customer.address.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer.address, "state", $$v)
                                  },
                                  expression: "customer.address.state"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Postcode" },
                                model: {
                                  value: _vm.customer.address.postcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.customer.address,
                                      "postcode",
                                      $$v
                                    )
                                  },
                                  expression: "customer.address.postcode"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary " },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveCustomer()
                                    }
                                  }
                                },
                                [_vm._v("Save Customer")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37b03288", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b03288","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/Customer.vue
// module id = null
// module chunks = 